import Index from 'src/pages/CostCenters/Index.vue'
import Create from 'src/pages/CostCenters/Create.vue'
import Edit from 'src/pages/CostCenters/Edit.vue'

const auth = { requiresAuth: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/cost_centers',
    name: 'Kostenstellen',
    component: Index,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/cost_centers/create',
    name: 'Kostenstelle Erstellen',
    component: Create,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/cost_centers/:id/edit',
    name: 'Kostenstelle Bearbeiten',
    component: Edit,
    meta: { ...auth, ...notUser }
  }
]
